import { EntityAudit } from "@modernary/mui/components/audit";
import {
  EntityDocumentForm,
  EntityDocumentMultipleForm,
  EntityDocumentsChildList,
} from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";
import { RouterView, type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  dustClasses: "DustClass.DustClasses",
  list: "DustClass.DustClassList",

  base: "DustClass.DustClassBase",
  view: "DustClass.DustClassView",
  new: "DustClass.DustClassNew",
  edit: "DustClass.DustClassEdit",
  roster: "DustClass.DustClassRoster",
  reschedule: "DustClass.DustClassReschedule",

  documents: "DustClass.DustClassDocuments",
  documentsEdit: "DustClass.DustClassDocumentsEdit",
  documentsNew: "DustClass.DustClassDocumentsNew",
  notes: "DustClass.DustClassNotes",
  noteEdit: "DustClass.DustClassNoteEdit",
  noteNew: "DustClass.DustClassNoteNew",
  audit: "DustClass.DustClassAudit",
};

export { names as dustClassRouteNames };

const dustClassRoutes: RouterOptions["routes"] = [
  {
    path: "/dustClass",
    name: names.dustClasses,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Dust Classes",
          lookupGroups: ["DustClassType"],
        },
        component: () => import("@/views/dustClass/DustClassList.vue"),
      },
      {
        path: "new",
        component: () => import("@/views/dustClass/DustClassBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "New Dust Class", isNew: true },
            component: () => import("@/views/dustClass/DustClassEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/dustClass/DustClassBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Dust Class View" },
            component: () => import("@/views/dustClass/DustClassView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Dust Class Edit", isForm: true },
            component: () => import("@/views/dustClass/DustClassEdit.vue"),
          },
          {
            path: "roster",
            name: names.roster,
            meta: { title: "Dust Class Roster" },
            component: () => import("@/views/dustClass/DustClassRoster.vue"),
          },
          {
            path: "reschedule",
            name: names.reschedule,
            meta: { title: "Reschedule Dust Class Attendees", isForm: true },
            component: () => import("@/views/dustClass/DustClassRescheduleAttendees.vue"),
          },

          {
            path: "documents",
            name: names.documents,
            meta: { title: "Dust Class Documents" },
            component: {
              render: () => <EntityDocumentsChildList resourceTypeKey="dustClass" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentsEdit,
            meta: { title: "Edit Dust Class Document", isForm: true },
            component: {
              render: () => <EntityDocumentForm resourceTypeKey="dustClass" />,
            },
          },
          {
            path: "documents/new",
            name: names.documentsNew,
            meta: { title: "Create Dust Class Documents", isForm: true },
            component: {
              render: () => <EntityDocumentMultipleForm resourceTypeKey="dustClass" />,
            },
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Dust Class Notes" },
            component: {
              render: () => <EntityNotes idField="dustClassId" routeNamePrefix="DustClass.DustClassNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit Dust Class Note", isForm: true },
            component: () => import("@/views/dustClass/DustClassNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create Dust Class Note", isForm: true },
            component: () => import("@/views/dustClass/DustClassNote.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Dust Class Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="DustClass" />,
            },
          },
        ],
      },
    ],
  },
];
export default dustClassRoutes;
